module.exports = __webpack_public_path__ + "img/ydjy.920128cd.svg";